export default __webpack_public_path__ + "static/plexus-full-width-4-mobile-0bdfd2884baaa649756bff58bbd6e067.webp";